export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_PACKAGES_DATE = 'SET_PACKAGES_DATE';
export const CHECK_FOR_NEW_PACKAGES = 'CHECK_FOR_NEW_PACKAGES';
export const CHECK_FOR_NEW_PACKAGES_AND_TASKS = 'CHECK_FOR_NEW_PACKAGES_AND_TASKS';
export const UPDATE_TASKS = 'UPDATE_TASKS';
export const SET_TASK_ASSETS = 'SET_TASK_ASSETS';
export const PACKAGE_DATA_UPDATE = 'PACKAGE_DATA_UPDATE';
export const SET_PACKAGE_DELETED = 'SET_PACKAGE_DELETED';

export const GENERATION_STATUS_FAILED = 'GENERATION_FAILED';
export const GENERATION_STATUS_HW_ON_DEMAND_PLACEHOLDER = 'HW_ON_DEMAND_PLACEHOLDER';

export function setPackages(packages, update = false) {
    return { type: SET_PACKAGES, packages, update };
}

export function setPackagesDate(date) {
    return { type: SET_PACKAGES_DATE, date };
}

export function checkForNewPackages(params) {
    const { force = false, inBackground = false } = params || {};
    return { type: CHECK_FOR_NEW_PACKAGES, force, inBackground };
}

export function checkForNewPackagesAndTasks(params) {
    const { force = false, inBackground = false } = params || {};
    return { type: CHECK_FOR_NEW_PACKAGES_AND_TASKS, force, inBackground };
}

export function updateTasks(tasks) {
    return { type: UPDATE_TASKS, tasks };
}

export function setTaskAssets(taskId, assets) {
    return { type: SET_TASK_ASSETS, taskId, assets };
}

export function packageDataUpdate(packageData) {
    return { type: PACKAGE_DATA_UPDATE, packageData };
}

export function setPackageDeleted(deletionData) {
    const { packageID, deletionTime } = deletionData || {};
    return { type: SET_PACKAGE_DELETED, packageID, deletionTime };
}
